import React, { memo } from 'react'
import JoditEditor from 'jodit-react'

// On utilise React.memo pour empêcher le re-render
// si les props spécifiques n'ont pas changé
const MemoizedJodit = memo(
  ({ value, config, onBlur, name }) => {
    return (
      <JoditEditor
        value={value}
        config={config}
        onBlur={(newContent) => {
          onBlur({
            target: { type: 'joditEditor', name: name, value: newContent }
          })
        }}
      />
    )
  },
  (prevProps, nextProps) => {
    // LOGIQUE CRUCIALE : On ne re-render QUE si la valeur externe change
    // (ex: chargement d'un autre produit) ou si le mode change.
    // On ignore les changements si l'utilisateur est juste en train de taper
    // dans un autre champ du formulaire.
    return prevProps.value === nextProps.value && prevProps.config.readonly === nextProps.config.readonly
  }
)

export default MemoizedJodit
